import "@rmlibrary/scroll";
import "./common";
import "createjs";
import "@rmlibrary/canvas-player-controls";
import "@rmlibrary/slider/src/custom-element.js";

import { attachDrawSwitch, loadAnimations } from "./animation";
import {
    buildTranscriptHTML,
    formatPortfolioAns,
    getLanguage,
    isChrome,
    isSafari,
    retrieveFromStorage,
    startsWithFrenchVowel
} from "./utilities";
import { generatePDF, setupPreview } from "./pdf";

import $ from "jquery";
import CanvasPlayer from "@rmlibrary/canvas-player";
import Formatter from "@rmlibrary/formatting";
import { getVolatilityVideoResults } from "./calculations";
import { storePrintValues } from "./storage";

const controls = document.getElementById("controls");
const language = getLanguage();
const formatter = new Formatter();

const cpContainer = document.querySelector(".cp-container");

const pdfReportButton = $(".pdf-report");
// let pdfGraphSrc = "";

let player = null;

let reachedFakePause = null;
let currentOpenPopup = null;

let animationFlow = [
    "volatility-Intro",
    "volatility-Scene1a",
    "Volatility-Scene2a",
    `Volatility-Results_1_iii_${window.enduser}`,
    `volatility-Ending-${window.enduser}`
];

const answers = {
    first: null,
    second: null,
    third: null
};

const answersForPDF = {
    first: null,
    second: null,
    third: null,
    name: "",
    chosenPortfolio: "",
    investmentAmount: -1
};

const decisionFrames = {
    initialInput: -1,
    decisionOne: -1,
    decisionTwo: -1,
    decisionThree: -1
};

let portfolioWorth = getVolatilityVideoResults(["i", "i", "i"]).map((value) => formatter.formatCurrency(value));

let bkgSoundInstance = undefined;
let firstTimePlay = true;

let labels = [];
let currentLabelInstance = null;

// let errMsgsTogglers;

const pageLoadPreloader = $(".cp-preloader").clone().removeClass("hide").attr("class", "page-load-preloader");
$(".volatility-video .right").prepend(pageLoadPreloader);
$(".volatility-video-thumbnail, .play-btn-small").hide();
$(".cp-overlay").addClass("hide");
$(".rm-slider-handle").attr("aria-label", "video progress bar");

$(".learn-more-btn").on("click", () => {
    updateAlertText(language === "en" ? "Opening link in new tab" : "Ouverture du lien dans un nouvel onglet");
    setTimeout(() => {
        window.open(language === "en" ? href="/en/insights-and-tools/learning/investing-essentials.html" : href="/fr/ressources-et-outils/apprentissage/notions-essentielles-de-placement.html", "_blank");
    }, 100);
});

const bkgLoadListener = createjs.default.Sound.on("fileload", () => {
    bkgSoundInstance = createjs.default.Sound.createInstance("bkgSound");
    bkgSoundInstance.loop = -1;
    bkgSoundInstance.volume = 1;
    createjs.default.Sound.off("fileload", bkgLoadListener);
    $(".page-load-preloader").remove();
    $(".cp-overlay").removeClass("hide");
    $(".volatility-video-thumbnail, .play-btn-small").show();
    $(".watch-video-btn, .play-btn-small").removeAttr("disabled");

    if (window.enduser === "customer") {
        // initPlayer(!isChrome() && !isSafari());
        initPlayer(true);
    }
});
createjs.default.Sound.registerSound(
    language === "fr"
        ? "./animate/volatility_video_clips-fr/sounds/one_step_up_.mp3"
        : "./animate/volatility_video_clips/sounds/one_step_up_.mp3",
    "bkgSound"
);

// Button to initialize video
$(".watch-video-btn, .play-btn-small").on("click", () => {
    $(".cp-controls").css("display", "flex");
    $(".cp-player").attr("aria-hidden", "false");
    $(".volatility-video-thumbnail, .play-btn-small").hide();
    $(".watch-video-btn").attr("disabled", "true");
    initPlayer(true);
});

const animationNames = translateAnimationNames([
    "volatility-Intro",
    "volatility-Scene1a",
    "volatility-Scene1b",
    "Volatility-Scene2a",
    "Volatility-Scene2b",
    `Volatility-Results_1_iii_${window.enduser}`,
    `Volatility-Results_2_iic_${window.enduser}`,
    `Volatility-Results_3_icc_${window.enduser}`,
    `Volatility-Results_4_ccc_${window.enduser}`,
    `Volatility-Results_5_cci_${window.enduser}`,
    `Volatility-Results_6_cii_${window.enduser}`,
    `Volatility-Results_7_ici_${window.enduser}`,
    `Volatility-Results_8_cic_${window.enduser}`,
    `volatility-Ending-${window.enduser}`
]);

function translateAnimationNames(animationNames) {
    return animationNames.map((animationName) => (language === "en" ? animationName : `${animationName}-fr`));
}

function filterSoundClipFunction(soundclip) {
    if (language === "en") {
        switch (stageVars.chosenPortfolio) {
            case "maximumGrowth":
                {
                    if (soundclip.id === "balancedPortfolio_VO" || soundclip.id === "growthPortfolio_VO") {
                        return false;
                    }
                }
                break;
            case "growth":
                {
                    if (soundclip.id === "balancedPortfolio_VO" || soundclip.id === "maxGrowthPortfolio_VO") {
                        return false;
                    }
                }
                break;
            case "balanced":
                {
                    if (soundclip.id === "growthPortfolio_VO" || soundclip.id === "maxGrowthPortfolio_VO") {
                        return false;
                    }
                }
                break;
        }
    }
    if (language === "fr") {
        switch (stageVars.chosenPortfolio) {
            case "maximumGrowth":
                {
                    if (soundclip.id === "balancedPortfolio_VO" || soundclip.id === "growthPortfolio_VO") {
                        return false;
                    }
                }
                break;
            case "growth":
                {
                    if (soundclip.id === "balancedPortfolio_VO" || soundclip.id === "maxGrowthPortfolio_VO") {
                        return false;
                    }
                }
                break;
            case "balanced":
                {
                    if (soundclip.id === "growthPortfolio_VO" || soundclip.id === "maxGrowthPortfolio_VO") {
                        return false;
                    }
                }
                break;
        }
    }
    return true;
}

const labelNames = [
    "skipIntroButton",
    "introInvest",
    "enable_click_skip",
    "disable_click_name",
    "enable_click_name",
    "enable_click_decision_one",
    "initial_input",
    // introMoveToCash: -1,

    "scene1StayInvested",
    "scene1aStayCash",
    "enable_click_scene1a",
    "afterSelection_scene1a",

    //Scene 1b
    "scene1Reinvest",
    "scene1bStayCash",
    "enable_click_scene1b",
    "afterSelection_scene1b",

    "scene2StayInvested",
    "Scene2SellCash",
    "enable_click_scene2a",
    "afterSelection_scene2a",

    "scene2Reinvest",
    "scene2StayCash",
    "enable_click_scene2b",
    "afterSelection_scene2b",

    "brexitBtn",
    "enable_click_results",

    "printBtn",
    "startOverBtn",
    "advisorBtn",

    "decisionOne",
    "decisionTwo",
    "decisionThree",
    "marketEvents"
];

let popupOpened = false;
let timeoutId = null;

let continuouslyInvestedPortfolioWorth = getVolatilityVideoResults(["invest", "invest", "invest"])[2];
let timingMarketPortfolioWorth = getVolatilityVideoResults(["cash", "invest", "invest"])[2];

const stageVars = {
    fakePause: function () {
        if (this.labels.filter((l) => l.label === "marketEvents").length > 0 && !timeoutId) {
            pauseForMarketEvents();
            // return;
        }
        player.pause();
        bkgSoundInstance.paused = false;
        reachedFakePause = true;
    },
    chosenPortfolio: "maximumGrowth",
    portfolioWorth,
    stageZeroPortfolioWorth: "",
    preBrexitPortfolioWorth: "",
    prePandemicPortfolioWorth: "",
    endInvestmentWorth: "",
    timingMarketPortfolioWorth: formatter.formatCurrency(timingMarketPortfolioWorth),
    continuouslyInvestedPortfolioWorth: formatter.formatCurrency(continuouslyInvestedPortfolioWorth),
    name: "",
    investmentAmount: "",
    handleInvestEvents: function () {
        fixReset(this);

        // #scene1StayInvested, #scene2Reinvest, #scene1Reinvest, #scene2StayInvested
        const btn = $("#introInvest, #scene1StayInvested, #scene2Reinvest, #scene1Reinvest, #scene2StayInvested");

        btn.off("mouseenter focus").on("mouseenter focus", () => {
            this.gotoAndPlay("btnHover");
        });

        btn.off("mouseleave blur").on("mouseleave blur", () => {
            this.gotoAndPlay("btnOut");
        });
    },
    handleCashEvents: function () {
        fixReset(this);

        //#scene1aStayCash, #scene1bStayCash, #Scene2SellCash, #scene2StayCash
        const btn = $("#introMoveToCash, #scene1aStayCash, #scene1bStayCash, #Scene2SellCash, #scene2StayCash");

        btn.off("mouseenter focus").on("mouseenter focus", () => {
            this.gotoAndPlay("btnHover");
        });

        btn.off("mouseleave blur").on("mouseleave blur", () => {
            this.gotoAndPlay("btnOut");
        });
    },
    handleMaxGrowthHover: function () {
        fixReset(this);

        const btn = $("#maximumGrowth");

        btn.off("mouseenter focus").on("mouseenter focus", () => {
            this.gotoAndPlay("btnHover");
        });

        btn.off("mouseleave blur").on("mouseleave blur", () => {
            this.gotoAndPlay("btnOut");
        });
    },
    handleGrowthHover: function () {
        fixReset(this);

        const btn = $("#growth");

        btn.off("mouseenter focus").on("mouseenter focus", () => {
            this.gotoAndPlay("btnHover");
        });

        btn.off("mouseleave blur").on("mouseleave blur", () => {
            this.gotoAndPlay("btnOut");
        });
    },
    handleBalancedHover: function () {
        fixReset(this);

        const btn = $("#balanced");

        btn.off("mouseenter focus").on("mouseenter focus", () => {
            this.gotoAndPlay("btnHover");
        });

        btn.off("mouseleave blur").on("mouseleave blur", () => {
            this.gotoAndPlay("btnOut");
        });
    },
    handleSkipIntroHover: function () {
        fixReset(this);

        const btn = $("#skipIntroButton");

        btn.off("mouseenter focus").on("mouseenter focus", () => {
            this.gotoAndPlay("btnHover");
        });

        btn.off("mouseleave blur").on("mouseleave blur", () => {
            this.gotoAndPlay("btnOut");
        });
    },
    registerPrintButton: function () {
        fixReset(this);

        const btn = $(".print-results");

        btn.off("mouseenter focus").on("mouseenter focus", () => {
            this.gotoAndPlay("btnHover");
        });

        btn.off("mouseleave blur").on("mouseleave blur", () => {
            this.gotoAndPlay("btnOut");
        });
    },
    registerPDFButton: function () {
        fixReset(this);

        const btn = $(".pdf-report");

        btn.off("mouseenter focus").on("mouseenter focus", () => {
            this.gotoAndPlay("btnHover");
        });

        btn.off("mouseleave blur").on("mouseleave blur", () => {
            this.gotoAndPlay("btnOut");
        });
    },
    registerAdvisorButton: function () {
        fixReset(this);

        const btn = $(".advisor");

        btn.off("mouseenter focus").on("mouseenter focus", () => {
            this.gotoAndPlay("btnHover");
        });

        btn.off("mouseleave blur").on("mouseleave blur", () => {
            this.gotoAndPlay("btnOut");
        });
    },
    handleDotcomEvents: handlePopupEvent("pandemic"),
    handleFinancialEvents: handlePopupEvent("fincrisis"),
    handleBrexitEvents: handlePopupEvent("brexit"),
    setName: function (id) {
        const el = document.getElementById(id);

        // If input field, focus and validate upon event
        if (el) {
            el.focus();
            el.setAttribute("maxlength", stageVars.limits.char.name.max);
            el.setAttribute("aria-label", language === "en" ? "Your name" : "Votre nom");
            el.setAttribute(
                "aria-description",
                language === "en" ? "Please enter your name" : "Veuillez inscrire votre nom"
            );
            if (stageVars.name) {
                el.value = stageVars.name;
            }

            // Validates name on any input
            el.addEventListener("input", (e) => {
                let inputName = e.target.value;
                inputName = inputName.replace(/[^ÀàÂâÄäÉéÈèÎîÖöÔôçÇa-zA-Z- /]/g, "");
                stageVars.name = inputName;
                e.target.value = inputName;
            });

            // Validates name on blur
            el.addEventListener("blur", (e) => {
                stageVars.name = e.target.value;
            });
        }
    },
    setInvestmentAmount: function (id) {
        const el = document.getElementById(id);

        // If input field, focus and validate upon event
        if (el) {
            el.setAttribute("inputmode", "numeric");
            el.setAttribute("maxlength", stageVars.limits.char.investmentAmount.max);
            el.setAttribute("aria-label", language === "en" ? "Your investment amount" : "Le montant du placement");
            el.setAttribute(
                "aria-description",
                language === "en"
                    ? "Please enter an investment amount between $500 and $1,000,000"
                    : "Veuillez inscrire un montant de 500 $ à 1 000 000 $"
            );
            if (stageVars.investmentAmount) {
                el.value = formatter.formatCurrency(stageVars.investmentAmount);
            }

            // Validates name on any input
            el.addEventListener("input", (e) => {
                let investmentInput = e.target.value.replace(/[^0-9]/g, "");
                if (e.inputType === "deleteContentBackward" && language === "fr") {
                    investmentInput = investmentInput.slice(0, investmentInput.length - 1);
                }
                if (investmentInput) {
                    const amount = formatter.formatCurrency(investmentInput);
                    e.target.value = amount;
                    stageVars.investmentAmount = investmentInput;
                } else {
                    e.target.value = "";
                }
            });
        }
    },
    showSelectedPortfolioGraph: function () {
        let instance = undefined;

        instance = this;

        if (stageVars.chosenPortfolio === "balanced") {
            if (
                instance.name === "simplified_balanced" ||
                instance.name === "graph_balanced" ||
                instance.name === "market_balanced"
            ) {
                instance.visible = true;
            } else {
                instance.visible = false;
            }
        } else if (stageVars.chosenPortfolio === "growth") {
            if (
                instance.name === "simplified_growth" ||
                instance.name === "graph_growth" ||
                instance.name === "market_growth"
            ) {
                instance.visible = true;
            } else {
                instance.visible = false;
            }
        } else if (stageVars.chosenPortfolio === "maximumGrowth") {
            if (
                instance.name === "simplified_maxgrowth" ||
                instance.name === "graph_maxgrowth" ||
                instance.name === "market_maxgrowth"
            ) {
                instance.visible = true;
            } else {
                instance.visible = false;
            }
        }
    },
    showGraphDot: function () {
        let instance = undefined;

        instance = this;

        if (stageVars.chosenPortfolio === "balanced") {
            if (instance.name === "dot_balanced") {
                instance.visible = true;
            } else {
                instance.visible = false;
            }
        } else if (stageVars.chosenPortfolio === "growth") {
            if (instance.name === "dot_growth") {
                instance.visible = true;
            } else {
                instance.visible = false;
            }
        } else if (stageVars.chosenPortfolio === "maximumGrowth") {
            if (instance.name === "dot_maxgrowth") {
                instance.visible = true;
            } else {
                instance.visible = false;
            }
        }
    },
    showErrorMessage: function () {
        let instance = undefined;

        if (this.investmentAmount_error) {
            instance = this.investmentAmount_error;
            if (
                stageVars.investmentAmount !== "" &&
                stageVars.investmentAmount &&
                +stageVars.investmentAmount >= 500 &&
                +stageVars.investmentAmount <= 1000000
            ) {
                instance.visible = false;
            } else {
                instance.visible = true;
            }
        } else if (this.nameInput_error) {
            instance = this.nameInput_error;
            if (stageVars.name !== "") {
                instance.visible = false;
            } else {
                instance.visible = true;
            }
        }
    },
    showName: function () {
        let instance = undefined;

        if (this.nameToday) {
            instance = this.nameToday;
        } else if (this.name12Months) {
            instance = this.name12Months;
        } else if (this.nameInvest) {
            instance = this.nameInvest;
        }

        let text = "";
        if (instance.name === "nameToday" || instance.name === "nameInvest") {
            if (language === "fr") {
                if (startsWithFrenchVowel(stageVars.name)) {
                    text = "Le placement d'[Name]";
                } else {
                    text = "Le placement de [Name]";
                }
            } else {
                text = "[Name]'s investment";
            }
        } else if (instance.name === "name12Months") {
            if (language === "fr") {
                if (startsWithFrenchVowel(stageVars.name)) {
                    text = "Le placement d'[Name] il y a 12 mois";
                } else {
                    text = "Le placement de [Name] il y a 12 mois";
                }
            } else {
                text = "[Name]'s investment \n12 months ago";
            }
            // } else if (instance.name === "nameInvest") {
            //     if (language === "fr") {
            //         if (startsWithFrenchVowel(stageVars.name)) {
            //             text = "Le placement d'[Name]";
            //         } else {
            //             text = "Le placement de [Name]";
            //         }
            //     } else {
            //         text = "[Name]'s investment";
            //     }
        }

        if (instance) {
            instance.text = text.replace(/\[Name\]/gi, stageVars.name);
        }
    },
    showInvestmentAmount: function () {
        let instance = undefined;

        if (this.initialValue) {
            instance = this.initialValue;
        } else if (this.initialValueReturn) {
            instance = this.initialValueReturn;
        } else if (this.return12Months) {
            instance = this.return12Months;
        } else if (this.returnPrePandemic) {
            instance = this.returnPrePandemic;
        }

        if (instance.name === "initialValue") {
            instance.text = formatter.formatCurrency(stageVars.investmentAmount, 0);
        } else if (instance.name === "initialValueReturn") {
            instance.text = formatter.formatCurrency(stageVars.stageZeroPortfolioWorth, 0);
        } else if (instance.name === "return12Months") {
            instance.text = formatter.formatCurrency(stageVars.preBrexitPortfolioWorth, 0);
        } else if (instance.name === "returnPrePandemic") {
            instance.text = formatter.formatCurrency(stageVars.prePandemicPortfolioWorth, 0);
        }
    },
    showPortfolioName: function () {
        let instance = undefined;

        if (this.assetAllocation) {
            instance = this.assetAllocation;
            if (instance.name === "assetAllocation") {
                if (stageVars.chosenPortfolio === "maximumGrowth") {
                    instance.text = instance.text.replace("[asset allocation]", "Maximum Growth");
                    instance.text = instance.text.replace("de [asset portfolio]", "de croissance maximale");
                } else if (stageVars.chosenPortfolio === "growth") {
                    instance.text = instance.text.replace("[asset allocation]", "Growth");
                    instance.text = instance.text.replace("de [asset portfolio]", "de croissance");
                } else if (stageVars.chosenPortfolio === "balanced") {
                    instance.text = instance.text.replace("[asset allocation]", "Balanced");
                    instance.text = instance.text.replace("de [asset portfolio]", "équilibré");
                }
            }
        }
    },
    showDisclaimerText: function () {
        let instance = undefined;

        if (this.disclaimerTiming) {
            instance = this.disclaimerTiming;
        } else if (this.disclaimerStaying) {
            instance = this.disclaimerStaying;
        }

        if (instance) {
            if (language === "en") {
                instance.text = instance.text
                    .replace("[investmentAmount]", formatter.formatCurrency(answersForPDF.investmentAmount))
                    .replace("[chosenPortfolio]", formatPortfolioAns(answersForPDF.chosenPortfolio));
            }
            if (language === "fr") {
                instance.text = instance.text
                    .replace(
                        "{montant du placement fusionné}",
                        formatter.formatCurrency(answersForPDF.investmentAmount)
                    )
                    .replace(
                        "{de croissance maximale / de croissance / équilibré}",
                        formatPortfolioAns(answersForPDF.chosenPortfolio)
                    );
            }
        }
    },
    handleButtonFocus: function(selector) {
        const button = document.querySelector(selector);
        button.focus();
    },
    updatePortfolio: function () {
        portfolioWorth = getVolatilityVideoResults(["i", "i", "i"]).map((value) => formatter.formatCurrency(value));
        continuouslyInvestedPortfolioWorth = getVolatilityVideoResults(["invest", "invest", "invest"])[2];
        timingMarketPortfolioWorth = getVolatilityVideoResults(["cash", "invest", "invest"])[2];
        this.timingMarketPortfolioWorth = formatter.formatCurrency(timingMarketPortfolioWorth);
        this.continuouslyInvestedPortfolioWorth = formatter.formatCurrency(continuouslyInvestedPortfolioWorth);
    },
    limits: {
        char: {
            name: {
                max: "20"
            },
            investmentAmount: {
                max: "10"
            }
        },
        amount: {
            investmentAmount: {
                min: "500",
                max: "1000000"
            }
        }
    }
};

let canDownloadPDF = false;
function setupImagePreload() {
    var graph = document.querySelector("#pdf-market-volatility-graph-src");

    if (!graph.complete || !graph.src) {
        canDownloadPDF = false;
        var timer = setTimeout(function () {
            // console.error("Image load timed out!", graph, graph.src);
        }, 5000);

        graph.addEventListener("load", function () {
            clearTimeout(timer);
            // console.log("Image loaded", graph, graph.src);
            canDownloadPDF = true;
        });
    } else {
        // console.log("Image already loaded", graph, graph.src);
        canDownloadPDF = true;
    }
}

// setupImagePreload();

function pauseForMarketEvents() {
    if (popupOpened) return;
    timeoutId = setTimeout(() => {
        player.play();
        clearTimeout(timeoutId);
        timeoutId = null;
    }, 3000);
}

function handlePopupEvent(buttonName) {
    const popupNames = {
        // dotcom: "popupDotcom",
        fincrisis: "popupFinancial",
        brexit: "popupChina",
        pandemic: "popupPandemic"
    };

    return function () {
        fixReset(this);
        fixReset(this.parent[popupNames[buttonName]]);
        if (this.parent.popupDisclosure) {
            fixReset(this.parent.popupDisclosure);
        }
        let hovered = false;

        $(`.${buttonName}`)
            .off("mouseenter focus")
            .on("mouseenter focus", () => {
                if (!hovered) {
                    this.gotoAndPlay("btnHover");
                    hovered = true;
                }
            });

        $(`.${buttonName}`)
            .off("mouseleave blur")
            .on("mouseleave blur", () => {
                if (hovered) {
                    this.gotoAndPlay("btnOut");
                    hovered = false;
                }
            });
        $(`.${buttonName}`)
            .off("click")
            .on("click", () => {
                popupOpened = true;
                this.parent[popupNames[buttonName]].gotoAndPlay("fadeIn");
                currentOpenPopup = this.parent[popupNames[buttonName]];
                if (buttonName === "dotcom" && language === "fr") {
                    // currentOpenPopup.children[1].alpha = 1;
                }

                if (timeoutId) {
                    clearTimeout(timeoutId);
                }

                if (language === "fr" && buttonName.indexOf("brexit") > -1) {
                    $(".close-popup").addClass("close-popup-brexit");
                }

                $(".brexit, .fincrisis, .dotcom, .pandemic").hide();
                $(".close-popup").show();
                $(`.${buttonName}-popup`).show();
                $(".close-popup")
                    .off("click")
                    .on("click", () => {
                        popupOpened = false;
                        this.parent[popupNames[buttonName]].gotoAndPlay("fadeOut");
                        currentOpenPopup = null;

                        this.gotoAndPlay("btnOut");
                        $(".brexit, .fincrisis, .dotcom, .pandemic").show();
                        $(".close-popup").hide();
                        $(".brexit-popup, .fincrisis-popup, .dotcom-popup, .pandemic-popup").hide();

                        if (language === "fr" && buttonName.indexOf("brexit") > -1) {
                            $(".close-popup").removeClass("close-popup-brexit");
                        }

                        if (timeoutId) {
                            pauseForMarketEvents();
                        }
                    });
            });
    };
}

function initPlayer(autoplay) {
    showHideOverlay(0);
    $(".cp-preloader").removeClass("hide");

    loadAnimations(language, animationNames, "animate/volatility_video_clips").then((animations) => {
        animations.forEach((animation) => {
            if (
                animation.meta.TITLE === "volatility-Ending-customer" ||
                animation.meta.TITLE === "volatility-Ending-advisor" ||
                animation.meta.TITLE === "volatility-Ending-customer-fr" ||
                animation.meta.TITLE === "volatility-Ending-advisor-fr"
            ) {
                const lib = animation.composition.getLibrary();

                attachDrawSwitch(
                    lib.disclosuretimingmarket,
                    () => answers.first !== "i" || answers.second !== "i" || answers.third !== "i"
                );
                attachDrawSwitch(
                    lib.disclosurestayinginvested,
                    () => answers.first === "i" && answers.second === "i" && answers.third === "i"
                );
            }
        });

        player = new CanvasPlayer(document.createElement("div"), animations, {
            autoplay: false,
            dynamicTimeline: animationNames,
            enableCC: false,
            pixelDensity: 1,
            rootName: undefined,
            backgroundMusic: {
                fadeOut: true
            },
            fonts: [
                `"Roobert"`,
                `"Roobert-bold"`
            ]
        });

        

        player.on("canplay", () => {
            player.destroy();
            initCanvasPlayer(autoplay, animations);
        });
    });
}

function initCanvasPlayer(autoplay, animations) {
    attachEventsToOverlayButtons(animations);

    player = new CanvasPlayer(cpContainer, animations, {
        autoplay,
        pixelDensity: devicePixelRatio,
        rootName: undefined,
        enableCC: true,
        dynamicTimeline: translateAnimationNames(animationFlow),
        stageVars,
        filterSoundClip: filterSoundClipFunction,
        backgroundMusic: {
            fadeOut: true
        },
        fonts: [
            `"Roobert"`,
            `"Roobert-bold"`
        ]
    });

    player.canvas.ariaLabel = language === "en" ? "Market Volatility video" : "vidéo de volatilité des marchés";

    player.on("canplay", () => {
        if (window.enduser === "customer") {
            const canvas = $("canvas").get(0);
            canvas.style.backgroundColor = "white";
        }

        updateTranscriptValues(player);
    });

    controls.toggleIndicators(true);
    controls.attachCanvasPlayer(player);

    attachEventsToCanvasPlayer();
}

function attachEventsToCanvasPlayer() {
    player.on("canplay", () => {
        searchLabelFrames();
        if (currentLabelInstance === undefined || currentLabelInstance === null) {
            currentLabelInstance = labels[0];
        }

        controls.frameLimit = decisionFrames.initialInput + 1;
    });

    player.on("play", () => {
        if (firstTimePlay) {
            bkgSoundInstance.play();
            firstTimePlay = false;
        } else {
            bkgSoundInstance.paused = false;
        }
    });
    player.on("pause", () => {
        if (player.ended) {
            bkgSoundInstance.stop();
            firstTimePlay = true;
        } else {
            bkgSoundInstance.paused = true;
        }
    });

    player.on("timeupdate", () => {
        setTimeout(() => {
            showHideOverlay(player.exportRoot.currentFrame);
        }, 25);
        const currentFrame = player.exportRoot.currentFrame;
        const totalFrames = player.exportRoot.totalFrames;
        if (currentFrame !== -1 && currentFrame < decisionFrames.initialInput) {
            controls.frameLimit = decisionFrames.initialInput + 1;
            clearDecisions();
        }
        if (totalFrames - currentFrame <= 100) {
            bkgSoundInstance._setVolume((totalFrames - currentFrame) / 100);
        } else {
            if (bkgSoundInstance._volume !== 1) {
                bkgSoundInstance._setVolume(1);
            }
        }
    });

    player.on("resizeEnd", () => {
        resizeButtonText();
    });

    controls.seekBar.addEventListener("rm-slider-up", () => {
        if (reachedFakePause && controls.frameLimit && player.exportRoot.currentFrame < controls.frameLimit) {
            player.play();
        }
        popupOpened = false;

        if (currentOpenPopup) {
            currentOpenPopup.gotoAndPlay("fadeOut");
            currentOpenPopup = null;
        }
    });
}

function updateAnswers() {
    let investorType =
        language === "en"
            ? "buy and hold investor"
            : "pour un investisseur qui aurait acheté et ensuite conservé ses placements";
    let investorMoneyAmount = continuouslyInvestedPortfolioWorth;
    let defaultDisclosure = true;
    let stayinginvestedDisclosure = false;

    if (answers.first === "i" && answers.second === "i" && answers.third === "i") {
        investorType =
            language === "en"
                ? "hypothetical investor who tried to time the market"
                : "pour un investisseur qui aurait tenté d'anticiper le marché";
        investorMoneyAmount = timingMarketPortfolioWorth;
        defaultDisclosure = false;
        stayinginvestedDisclosure = true;
    }

    let finalAmounts = {
        topValue: {
            value: "0",
            text: ""
        },
        bottomValue: {
            value: "0",
            text: ""
        }
    };
    if (getScenario() === "iii") {
        finalAmounts.topValue.value = formatter.formatCurrency(stageVars.continuouslyInvestedPortfolioWorth);
        finalAmounts.topValue.text =
            language === "en"
                ? answersForPDF.name + "'s investment"
                : startsWithFrenchVowel(answersForPDF.name)
                ? "Le placement d'" + answersForPDF.name
                : "Le placement de " + answersForPDF.name;
        finalAmounts.bottomValue.value = formatter.formatCurrency(stageVars.timingMarketPortfolioWorth);
        finalAmounts.bottomValue.text = language === "fr" ? "Prévoir les aléas du marché" : "Timing the market";
    } else {
        finalAmounts.topValue.value = formatter.formatCurrency(stageVars.continuouslyInvestedPortfolioWorth);
        finalAmounts.topValue.text = language === "fr" ? "Maintenir ses placements" : "Continuously invested";
        finalAmounts.bottomValue.value = formatter.formatCurrency(stageVars.portfolioWorth[2]);
        finalAmounts.bottomValue.text =
            language === "en"
                ? answersForPDF.name + "'s investment"
                : startsWithFrenchVowel(answersForPDF.name)
                ? "Le placement d'" + answersForPDF.name
                : "Le placement de " + answersForPDF.name;
    }
    let deFormat = startsWithFrenchVowel(answersForPDF.name) ? "d'" : "de ";
    storePrintValues(
        getImageName(answers.first, answers.second, answers.third, stageVars.chosenPortfolio),
        answersForPDF,
        formatter.formatCurrency(stageVars.portfolioWorth[2]),
        formatter.formatCurrency(investorMoneyAmount),
        investorType,
        defaultDisclosure,
        stayinginvestedDisclosure,
        deFormat,
        finalAmounts
    );
    updatePdfGraphSrc();
    setupImagePreload();
}

function updatePdfGraphSrc() {
    const img = getImagePath();
    $("#pdf-market-volatility-graph-src").attr("src", img);
    // console.log("path:", img);
}

function validateInitialInputs() {
    if (!stageVars.name) {
        document.getElementById("nameErr").style.visibility = "visible";
        return false;
    }
    if (!stageVars.investmentAmount || +stageVars.investmentAmount < 500 || +stageVars.investmentAmount > 1000000) {
        document.getElementById("amountErr").style.visibility = "visible";
        return false;
    }
    return true;
}

function clearDecisions() {
    answers.first = null;
    answers.second = null;
    answers.third = null;
    answersForPDF.first = null;
    answersForPDF.second = null;
    answersForPDF.third = null;
}

function attachEventsToOverlayButtons() {
    $(".overlay-btn").on("click", function (event) {
        const targetId = event.target.id;

        if (event.target.classList.contains("asset-allocation-btn")) {
            stageVars.chosenPortfolio = targetId;
            answersForPDF.chosenPortfolio = stageVars.chosenPortfolio;
            stageVars.updatePortfolio();
        }

        const frameSkip = Number(event.target.getAttribute("frameSkip"));
        if (targetId === "skipIntroButton") {
            player.goToFrame(frameSkip);
            return;
        }

        if (targetId === "maximumGrowth" || targetId === "growth" || targetId === "balanced") {
            clearDecisions();
            const valid = validateInitialInputs(targetId);
            if (!valid) {
                return;
            }
            answers.assetAllocation = targetId;
            answersForPDF.assetAllocation = targetId;
            answersForPDF.name = stageVars.name;
            answersForPDF.investmentAmount = stageVars.investmentAmount;
        } else if (targetId === "introInvest") {
            animationFlow[1] = "volatility-Scene1a";
            answers.first = "i";
            answersForPDF.first = event.target.innerText.trim();
        } else if (targetId === "introMoveToCash") {
            animationFlow[1] = "volatility-Scene1b";
            answers.first = "c";
            answersForPDF.first = event.target.innerText.trim();
        } else if (targetId === "scene1StayInvested" || targetId === "scene1Reinvest") {
            animationFlow[2] = "Volatility-Scene2a";
            answers.second = "i";
            answersForPDF.second = event.target.innerText.trim();
        } else if (targetId === "scene1aStayCash" || targetId === "scene1bStayCash") {
            animationFlow[2] = "Volatility-Scene2b";
            answers.second = "c";
            answersForPDF.second = event.target.innerText.trim();
        } else if (targetId === "scene2StayInvested" || targetId === "scene2Reinvest") {
            answers.third = "i";
            animationFlow[4] = `volatility-Ending-${window.enduser}`;
            answersForPDF.third = event.target.innerText.trim();
        } else if (targetId === "Scene2SellCash" || targetId === "scene2StayCash") {
            answers.third = "c";
            animationFlow[4] = `volatility-Ending-${window.enduser}`;
            answersForPDF.third = event.target.innerText.trim();
        } else {
            return;
        }

        stageVars.portfolioWorth = getVolatilityVideoResults([answers.first, answers.second, answers.third]).map(
            (value) => formatter.formatCurrency(value)
        );

        if (answers.first !== null && answers.second !== null && answers.third !== null) {
            animationFlow[3] = findResult();
        }

        player.reflow(translateAnimationNames(animationFlow), { frameNum: frameSkip });
        searchLabelFrames();
        showHideOverlay(player.exportRoot.currentFrame);

        updateTranscriptValues(player);

        $(".cp-thumbnail").addClass("hide");
        $(".cp-large-play").addClass("hide");
        player.play();

        reachedFakePause = false;

        if (!answers.assetAllocation) {
            controls.frameLimit = decisionFrames.initialInput + 1;
        } else if (!answers.first) {
            controls.frameLimit = decisionFrames.decisionOne - 1;
        } else if (!answers.second) {
            controls.frameLimit = decisionFrames.decisionTwo - 1;
        } else if (!answers.third) {
            controls.frameLimit = decisionFrames.decisionThree - 1;
        } else {
            controls.clearFrameLimit();
        }

        // update pdf graph src to pre-load the image
        if (answers.third) {
            updateAnswers();
            updatePdfGraphSrc();
        }
    });

    // setup pdf report button
    pdfReportButton.on("click", () => {
        updateAnswers(); // updates answers and pdf graph src
        const storedInputs = retrieveFromStorage("volatility");
        const format = language === "en" ? "mmmm ddd, yyyy" : "ddd mmmm yyyy";
        const date = formatter.formatDate(new Date(), format);
        const defaultDisclosure =
            language === "en"
                ? `Dynamic Funds® is a registered trademark of its owner, used under license, and a division of 1832 Asset Management L.P. 
                For illustrative purposes only. The illustration shows the hypothetical growth of ${formatter.formatCurrency(
                    answersForPDF.investmentAmount
                )} invested in the 
                ${formatPortfolioAns(
                    answersForPDF.chosenPortfolio
                )} portfolio between December 31, 2002 and December 31, 2022. The Maximum Growth, Growth and Balanced portfolios used in 
                this illustration are hypothetical in nature and are represented by the following (indices parenthesized): Maximum Growth 
                portfolio (100% S&P/TSX Composite TR Index), Growth portfolio (75% S&P/TSX Composite TR Index, 25% FTSE Canada Universe 
                Bond Index), Balanced portfolio (50% S&P/TSX Composite TR Index, 50% FTSE Canada Universe Bond Index). Cash uses a 
                hypothetical 1.25% rate of return. Assumes reinvestment of all income and no transaction costs or taxes. Indices are not 
                managed and it is not possible to invest directly in an index. The illustration is hypothetical and does not reflect actual 
                results or the future returns or future value of a mutual fund or any other investment. Comparison scenario assumes "Stay 
                Invested" was chosen at each decision point.`
                : `Fonds Dynamiqueᴹᴰ est une marque déposée de son propriétaire, utilisée sous licence, et une division de Gestion d’actifs 
                1832 S.E.C. À titre indicatif seulement. Ce graphique illustre l'incidence de diverses stratégies de placement hypothéthique 
                de ${formatter.formatCurrency(answersForPDF.investmentAmount)}
                dans le portefeuille ${formatPortfolioAns(
                    answersForPDF.chosenPortfolio
                )}  entre les 31 décembre 2002 et 2022. Les portefeuilles de croissance maximale, de croissance et équilibré dans le graphique 
                sont hypothétiques et sont représenteés par les indices suivants\u00A0: 100\u00A0% S&P/TSX composé (RT) (portefeuille de croissance 
                maximale); 75\u00A0% S&P/TSX composé (RT) et 25\u00A0% FTSE Canada des obligations universelles (portefeuille de croissance); 50\u00A0% 
                S&P/TSX composé (RT) et 50\u00A0% FTSE Canada des obligations universelles (portefeuille équilibré). Pour les liquidités, un taux 
                de rendement hypothétique est de 1,25\u00A0%. On suppose que tous les revenus sont réinvestis et qu'il n'y a pas de frais de transaction 
                ni d'impôts. Les indices ne sont pas gérés et il n'est pas possible d'investir directement dans un indice. Ce graphique est 
                hypothétique et ne reflète pas des résultats réels, ni la valeur future ou le rendement d'un fonds commun ou d'un quelconque 
                placement. Ce document n'a pas pour but de fournir des conseils de placement. La simulation suppose que l'investisseur choisit 
                d'investir à long terme à chaque moment décisif.`;
        const stayInvestedDisclosure =
            language === "en"
                ? `Dynamic Funds® is a registered trademark of its owner, used under license, and a division of 1832 Asset Management L.P. 
                For illustrative purposes only. The illustration shows the hypothetical growth of ${formatter.formatCurrency(
                    answersForPDF.investmentAmount
                )} invested in the 
                ${formatPortfolioAns(
                    answersForPDF.chosenPortfolio
                )} portfolio between December 31, 2002 and December 31, 2022. The Maximum Growth, Growth and Balanced portfolios used in 
                this illustration are hypothetical in nature and are represented by the following (indices parenthesized): Maximum Growth 
                portfolio (100% S&P/TSX Composite TR Index), Growth portfolio (75% S&P/TSX Composite TR Index, 25% FTSE Canada Universe 
                Bond Index), Balanced portfolio (50% S&P/TSX Composite TR Index, 50% FTSE Canada Universe Bond Index). Cash uses a 
                hypothetical 1.25% rate of return. Assumes reinvestment of all income and no transaction costs or taxes. Indices are not 
                managed and it is not possible to invest directly in an index. The illustration is hypothetical and does not reflect actual 
                results or the future returns or future value of a mutual fund or any other investment. Market timing comparison scenario 
                assumes the following decisions: "Move to Cash" at decision 1, "Reinvest" at decision 3, and "Stay Invested" at decision 3.`
                : `Fonds Dynamiqueᴹᴰ est une marque déposée de son propriétaire, utilisée sous licence, et une division de Gestion d’actifs 
                1832 S.E.C. À titre indicatif seulement. Ce graphique illustre l'incidence de diverses stratégies de placement hypothéthique 
                de ${formatter.formatCurrency(answersForPDF.investmentAmount)}
                dans le portefeuille ${formatPortfolioAns(
                    answersForPDF.chosenPortfolio
                )} entre les 31 décembre 2002 et 2022. Les portefeuilles de croissance maximale, de croissance et équilibré dans le graphique 
                sont hypothétiques et sont représenteés par les indices suivants\u00A0: 100\u00A0% S&P/TSX composé (RT) (portefeuille de croissance 
                maximale); 75\u00A0% S&P/TSX composé (RT) et 25\u00A0% FTSE Canada des obligations universelles (portefeuille de croissance); 50\u00A0% 
                S&P/TSX composé (RT) et 50\u00A0% FTSE Canada des obligations universelles (portefeuille équilibré). Pour les liquidités, un taux 
                de rendement hypothétique est de 1,25\u00A0%. On suppose que tous les revenus sont réinvestis et qu'il n'y a pas de frais de transaction 
                ni d'impôts. Les indices ne sont pas gérés et il n'est pas possible d'investir directement dans un indice. Ce graphique est 
                hypothétique et ne reflète pas des résultats réels, ni la valeur future ou le rendement d'un fonds commun ou d'un quelconque 
                placement. Ce document n'a pas pour but de fournir des conseils de placement. La simulation d'anticipation de marché compare 
                les trois stratégies potentielles suivantes\u00A0: 1) Adopter une position au comptant, 2) Réinvestir et 3) Investir à long terme.`;

        $("#pdf-market-volatility-date").text(date);
        $(".inputName").text(answersForPDF.name);
        $("#asset-type").text(formatPortfolioAns(answersForPDF.chosenPortfolio));
        $("#asset-type-title").text(formatPortfolioAns(answersForPDF.chosenPortfolio));
        $("#de-format").text(startsWithFrenchVowel(answersForPDF.name) ? "d'" : "de ");
        $("#pdf-market-volatility-first-answer").text(answersForPDF.first.toLowerCase());
        $("#pdf-market-volatility-second-answer").text(answersForPDF.second.toLowerCase());
        $("#pdf-market-volatility-third-answer").text(answersForPDF.third.toLowerCase());
        $("#pdf-market-volatility-portfolio-worth").text(stageVars.portfolioWorth[2]);
        $("#pdf-market-volatility-other-investor").text(
            getScenario() === "iii"
                ? stageVars.timingMarketPortfolioWorth
                : stageVars.continuouslyInvestedPortfolioWorth
        );
        $("#pdf-market-volatility-investor-type").text(storedInputs.investorType);

        $("[data-id='deText']").each((_index, element) => {
            const adjacentText = $(element).next().text();
            if (startsWithFrenchVowel(adjacentText)) {
                $(element).text("d'");
                $(element).css("font-weight", "bold");
            } else {
                $(element).text("de ");
                $(element).css("font-weight", "bold");
            }
        });

        if (storedInputs.defaultDisclosure === false) {
            $("#disclosure-text").text(stayInvestedDisclosure);
        } else {
            $("#disclosure-text").text(defaultDisclosure);
        }
        setGraphValues();

        if (canDownloadPDF) {
            generatePDF();
        }
        //generatePDF();
    });

    function setGraphValues() {
        const EN_VALUE_ALIGNMENTS = {
            "ccc-balanced": {
                startingAmount: "61.5%",
                continuous: "37%",
                timing: "53%"
            },
            "ccc-growth": {
                startingAmount: "61.8%",
                continuous: "34%",
                timing: "53%"
            },
            "ccc-maxgrowth": {
                startingAmount: "60%",
                continuous: "34%",
                timing: "53%"
            },
            "cci-balanced": {
                startingAmount: "62%",
                continuous: "36%",
                timing: "48.5%"
            },
            "cci-growth": {
                startingAmount: "62%",
                continuous: "33.5%",
                timing: "45%"
            },
            "cci-maxgrowth": {
                startingAmount: "62%",
                continuous: "32.5%",
                timing: "44%"
            },
            "cic-balanced": {
                startingAmount: "62%",
                continuous: "36.5%",
                timing: "51.5%"
            },
            "cic-growth": {
                startingAmount: "61%",
                continuous: "33.5%",
                timing: "51%"
            },
            "cic-maxgrowth": {
                startingAmount: "60%",
                continuous: "33.5%",
                timing: "51%"
            },
            "cii-balanced": {
                startingAmount: "62%",
                continuous: "34.5%",
                timing: "45%"
            },
            "cii-growth": {
                startingAmount: "61%",
                continuous: "31%",
                timing: "42%"
            },
            "cii-maxgrowth": {
                startingAmount: "61%",
                continuous: "30%",
                timing: "41.5%"
            },
            "icc-balanced": {
                startingAmount: "61%",
                continuous: "33%",
                timing: "44.5%"
            },
            "icc-growth": {
                startingAmount: "62%",
                continuous: "30.5%",
                timing: "44%"
            },
            "icc-maxgrowth": {
                startingAmount: "61%",
                continuous: "32.5%",
                timing: "45.5%"
            },
            "ici-balanced": {
                startingAmount: "61.5%",
                continuous: "31%",
                timing: "42%"
            },
            "ici-growth": {
                startingAmount: "61.5%",
                continuous: "26%",
                timing: "37%"
            },
            "ici-maxgrowth": {
                startingAmount: "60.5%",
                continuous: "27%",
                timing: "38%"
            },
            "iic-balanced": {
                startingAmount: "62.5%",
                continuous: "30%",
                timing: "42.5%"
            },
            "iic-growth": {
                startingAmount: "61.5%",
                continuous: "30%",
                timing: "43%"
            },
            "iic-maxgrowth": {
                startingAmount: "59%",
                continuous: "32%",
                timing: "44%"
            },
            "iii-balanced": {
                startingAmount: "61.5%",
                continuous: "36%",
                timing: "46%"
            },
            "iii-growth": {
                startingAmount: "61.5%",
                continuous: "31.5%",
                timing: "42%"
            },
            "iii-maxgrowth": {
                startingAmount: "60%",
                continuous: "30.5%",
                timing: "41%"
            }
        };
        const FR_VALUE_ALIGNMENTS = {
            "ccc-balanced": {
                startingAmount: "61.5%",
                continuous: "38%",
                timing: "54%"
            },
            "ccc-growth": {
                startingAmount: "61.8%",
                continuous: "33%",
                timing: "52%"
            },
            "ccc-maxgrowth": {
                startingAmount: "60%",
                continuous: "33%",
                timing: "50.5%"
            },
            "cci-balanced": {
                startingAmount: "62%",
                continuous: "36.5%",
                timing: "49%"
            },
            "cci-growth": {
                startingAmount: "62%",
                continuous: "32.5%",
                timing: "44%"
            },
            "cci-maxgrowth": {
                startingAmount: "62%",
                continuous: "32%",
                timing: "42%"
            },
            "cic-balanced": {
                startingAmount: "62%",
                continuous: "37%",
                timing: "51.5%"
            },
            "cic-growth": {
                startingAmount: "61%",
                continuous: "35%",
                timing: "51.5%"
            },
            "cic-maxgrowth": {
                startingAmount: "60%",
                continuous: "35%",
                timing: "51.5%"
            },
            "cii-balanced": {
                startingAmount: "62%",
                continuous: "35%",
                timing: "47%"
            },
            "cii-growth": {
                startingAmount: "61%",
                continuous: "33%",
                timing: "43.5%"
            },
            "cii-maxgrowth": {
                startingAmount: "61%",
                continuous: "32%",
                timing: "43%"
            },
            "icc-balanced": {
                startingAmount: "61%",
                continuous: "35%",
                timing: "45.5%"
            },
            "icc-growth": {
                startingAmount: "62%",
                continuous: "33%",
                timing: "45%"
            },
            "icc-maxgrowth": {
                startingAmount: "61%",
                continuous: "34%",
                timing: "47%"
            },
            "ici-balanced": {
                startingAmount: "61.5%",
                continuous: "33%",
                timing: "43.5%"
            },
            "ici-growth": {
                startingAmount: "61.5%",
                continuous: "29.5%",
                timing: "40%"
            },
            "ici-maxgrowth": {
                startingAmount: "60.5%",
                continuous: "30%",
                timing: "40.5%"
            },
            "iic-balanced": {
                startingAmount: "62.5%",
                continuous: "34%",
                timing: "44.5%"
            },
            "iic-growth": {
                startingAmount: "61.5%",
                continuous: "33%",
                timing: "44%"
            },
            "iic-maxgrowth": {
                startingAmount: "59%",
                continuous: "33.5%",
                timing: "44.5%"
            },
            "iii-balanced": {
                startingAmount: "61.5%",
                continuous: "38%",
                timing: "48%"
            },
            "iii-growth": {
                startingAmount: "61.5%",
                continuous: "32%",
                timing: "43%"
            },
            "iii-maxgrowth": {
                startingAmount: "60%",
                continuous: "31.5%",
                timing: "42.5%"
            }
        };

        $("#starting-investment-dollar").text(formatter.formatCurrency(answersForPDF.investmentAmount));
        $("#continuously-invested-dollar").text(stageVars.continuouslyInvestedPortfolioWorth);

        if (getScenario() === "iii") {
            if (language === "fr") {
                if (startsWithFrenchVowel(answersForPDF.name)) {
                    $("#continuously-invested-identity").text(`Le placement d'${answersForPDF.name}`);
                } else {
                    $("#continuously-invested-identity").text(`Le placement de ${answersForPDF.name}`);
                }
                $("#timing-market-identity").text("Prévoir les aléas du marché");
            } else {
                $("#continuously-invested-identity").text(`${answersForPDF.name}'s investment`);
                $("#timing-market-identity").text("Timing the market");
            }
            $("#timing-market-dollar").text(stageVars.timingMarketPortfolioWorth);
        } else {
            if (language === "fr") {
                if (startsWithFrenchVowel(answersForPDF.name)) {
                    $("#timing-market-identity").text(`Le placement d'${answersForPDF.name}`);
                } else {
                    $("#timing-market-identity").text(`Le placement de ${answersForPDF.name}`);
                }
                $("#continuously-invested-identity").text("Maintenir ses placements");
            } else {
                $("#timing-market-identity").text(`${answersForPDF.name}'s investment`);
                $("#continuously-invested-identity").text("Continuously invested");
            }
            $("#timing-market-dollar").text(stageVars.portfolioWorth[2]);
        }

        const styles =
            language === "en"
                ? EN_VALUE_ALIGNMENTS[`${getScenario()}-${getPNGPortfolioName()}`]
                : FR_VALUE_ALIGNMENTS[`${getScenario()}-${getPNGPortfolioName()}`];
        $(".starting-investment").css("top", styles.startingAmount);
        $(".continuously-invested").css("top", styles.continuous);
        $(".timing-market").css("top", styles.timing);
    }

    $(".print-results").on("click", () => {
        updateAlertText(language === "en" ? "Opening print preview in new tab" : "Ouverture de l'aperçu avant impression dans un nouvel onglet");
        setTimeout(() => {
            updateAnswers();
            window.open("print.html");
        })
    });

    $(".pdf-report").on("click", () => {
        updateAlertText(language === "en" ? "Opening PDF" : "Ouverture du PDF");
    });

    $(".start-over").on("click", () => {
        updateAlertText(language === "en" ?"Starting over" : "Recommencement");
        bkgSoundInstance.stop();
        firstTimePlay = true;
        answers.first = answers.second = answers.third = null;
        answersForPDF.first = answersForPDF.second = answersForPDF.third = null;
        answersForPDF.name = null;
        answersForPDF.investmentAmount = null;
        stageVars.chosenPortfolio = "";
        stageVars.investmentAmount = null;
        controls.frameLimit = decisionFrames.initialInput + 1;
        player.pause();
        stageVars.handleButtonFocus(".cp-pause");
        controls.replay();
    });
}

function updateAlertText(text) {
    $(".alert-text").text(text)
    setTimeout(() => {
        $(".alert-text").text("")
    }, 0);
}

function getScenario() {
    let res = "";
    res += getDecision(answersForPDF.first);
    res += getDecision(answersForPDF.second);
    res += getDecision(answersForPDF.third);

    return res;
}

function getDecision(choice) {
    if (choice.includes("cash") || choice.includes("comptant") || choice.includes("liquidités")) {
        return "c";
    }
    return "i";
}

function getPNGPortfolioName() {
    if (answersForPDF.chosenPortfolio === "balanced") {
        return "balanced";
    } else if (answersForPDF.chosenPortfolio === "maximumGrowth") {
        return "maxgrowth";
    } else {
        return "growth";
    }
}

function getImagePath() {
    const scenario = getScenario();
    let imageName;

    imageName = `${scenario}-${getPNGPortfolioName()}.png`;

    if (language === "fr") {
        imageName = `fr-${imageName}`;
    }

    return `./common/images/print/volatility-scenarios/${imageName}`;
}

function showHideOverlay(currentFrame) {
    if (labels.length !== 0) {
        let currentLabelPosition = currentLabelInstance.position;
        const currentVideoFrame = currentFrame - 1;

        labels.forEach((l) => {
            if (currentVideoFrame >= l.position) {
                currentLabelInstance = l;
                currentLabelPosition = l.position;
            }
        });

        if (currentVideoFrame >= currentLabelPosition) {
            if (currentLabelInstance.label.includes("enable_click_name")) {
                $(".cp-overlay").fadeOut(500);
            } else if (currentLabelInstance.label.includes("enable_click")) {
                $(".cp-overlay").hide();
                $(".cp-overlay>*").hide();
            } else {
                if (
                    ($(`.${currentLabelInstance.label}`).is(":hidden") && !popupOpened) ||
                    currentLabelInstance.label === "disable_click_name"
                ) {
                    $(".cp-large-play").addClass("hide");
                    $(".cp-overlay").show();
                    $(".cp-overlay>*").hide();
                    $(`.${currentLabelInstance.label}`).show();

                    if (window.enduser === "advisor") {
                        $(".advisor").hide();
                        $(`.startOverBtn`).removeClass("customer");
                    } else {
                        $(`.startOverBtn`).addClass("customer");
                    }
                } else if ($(".popup-close").is("hidden")) {
                    $(".popup-close").show();
                }
                resizeButtonText();
            }
        } else {
            $(".cp-overlay").hide();
            $(".cp-overlay>*").hide();
        }
    } else {
        $(".cp-overlay").hide();
        $(".cp-overlay>*").hide();
    }
}

function searchLabelFrames() {
    const exportRoot = player.exportRoot;
    labels = [];

    if (exportRoot.dynamicScenes) {
        let currentStartFrame = 0;
        exportRoot.dynamicScenes.forEach((scene) => {
            const animLabels = scene.inst.labels;
            animLabels.forEach((l) => {
                if (labelNames.indexOf(l.label) !== -1) {
                    const label = Object.assign({}, l);
                    label.position += currentStartFrame;
                    labels.push(label);

                    if (label.label === "afterSelection_scene1a") {
                        $(".scene1StayInvested").attr("frameSkip", label.position);
                    } else if (label.label === "afterSelection_scene1b") {
                        $(".scene1bStayCash").attr("frameSkip", label.position);
                    } else if (label.label === "afterSelection_scene2a") {
                        $(".Scene2SellCash").attr("frameSkip", label.position);
                    } else if (label.label === "afterSelection_scene2b") {
                        $(".scene2StayCash").attr("frameSkip", label.position);
                    }

                    if (label.label === "initial_input") {
                        decisionFrames.initialInput = label.position;
                    } else if (label.label == "decisionOne") {
                        decisionFrames.decisionOne = label.position;
                    } else if (label.label === "decisionTwo") {
                        decisionFrames.decisionTwo = label.position;
                    } else if (label.label === "decisionThree") {
                        decisionFrames.decisionThree = label.position;
                    }
                }
            });

            currentStartFrame += scene.inst.duration;
        });
    } else {
        exportRoot.labels.forEach((l) => {
            if (labelNames.indexOf(l.label) !== -1) {
                const label = Object.assign({}, l);
                labels.push(label);
            }
        });
    }
}

function findResult() {
    if (answers.first === "i" && answers.second === "i" && answers.third === "i") {
        return `Volatility-Results_1_iii_${window.enduser}`;
    } else if (answers.first === "i" && answers.second === "i" && answers.third === "c") {
        return `Volatility-Results_2_iic_${window.enduser}`;
    } else if (answers.first === "i" && answers.second === "c" && answers.third === "c") {
        return `Volatility-Results_3_icc_${window.enduser}`;
    } else if (answers.first === "c" && answers.second === "c" && answers.third === "c") {
        return `Volatility-Results_4_ccc_${window.enduser}`;
    } else if (answers.first === "c" && answers.second === "c" && answers.third === "i") {
        return `Volatility-Results_5_cci_${window.enduser}`;
    } else if (answers.first === "c" && answers.second === "i" && answers.third === "i") {
        return `Volatility-Results_6_cii_${window.enduser}`;
    } else if (answers.first === "i" && answers.second === "c" && answers.third === "i") {
        return `Volatility-Results_7_ici_${window.enduser}`;
    } else if (answers.first === "c" && answers.second === "i" && answers.third === "c") {
        return `Volatility-Results_8_cic_${window.enduser}`;
    }
}

function resizeButtonText() {
    let width = $("#skipIntroButton").outerWidth();
    let fontRatio = language === "fr" ? 0.100478468899521 : 0.11538461538461539;
    let paddingRatio = language === "fr" ? 0.031632110579479 : 0.03632478632478633;

    $("#skipIntroButton").css("font-size", width * fontRatio);
    $("#skipIntroButton").css("padding-top", width * paddingRatio);

    width = $("#introInvest").outerWidth();
    fontRatio = 0.11225806451612902;
    paddingRatio = 0.041362373166160406;

    $(".stay-invested-btn, .move-to-cash-btn").css("font-size", width * fontRatio);
    $(".stay-invested-btn, .move-to-cash-btn").css("padding-top", width * paddingRatio);

    width = $(".results").outerWidth();
    fontRatio = 0.09597315436241612;
    $(".results").css("font-size", width * fontRatio);

    width = $(".printBtn").outerWidth();
    fontRatio = language === "en" ? 0.11327175498298495 : 0.07813689849;
    paddingRatio = 0.08305785123966942;
    $(".pdf-report, .print-results, .advisor").css("font-size", width * fontRatio);
    $(".pdf-report, .print-results").css("padding-top", width * paddingRatio);

    width = $("canvas").outerWidth();
    fontRatio = 0.019178082191780823;
    $(".start-over").css("font-size", width * fontRatio);
}

function fixReset(instance) {
    if (!instance._reset_fixed) {
        var old_reset = instance._reset;
        instance._reset = function () {
            old_reset.call(this);
            this.paused = true;
        };
        instance._reset_fixed = true;
    }
}

function getImageName(answer1, answer2, answer3, chosenPortfolio) {
    if (language === "en")
        return (
            answer1 + answer2 + answer3 + "-" + (chosenPortfolio === "maximumGrowth" ? "maxgrowth" : chosenPortfolio)
        );
    if (language === "fr")
        return (
            "fr-" +
            answer1 +
            answer2 +
            answer3 +
            "-" +
            (chosenPortfolio === "maximumGrowth" ? "maxgrowth" : chosenPortfolio)
        );
}

if (window.location.search === "?pdf") {
    setupPreview();
}

function updateTranscriptValues(player) {
    let descriptions = player.generateTranscript();
    descriptions = sanitiseDescriptions(descriptions);

    const illustrativePurposesDisclaimer = language === "en" ? "For illustrative purposes only. The illustration shows the hypothetical growth of [initialValue] invested in the [chosenPortfolio] portfolio between December 31, 2022 and December 31, 2022. The Maximum Growth, Growth, and Balanced portfolios used in this illustration are hypothetical in nature and are represented by the following (indexes parenthesized): Maximum Growth portfolio (100% S&P/TSX Composite TR Index), Growth portfolio (75% S&P/TSX Composite TR Index, 25% FTSE Canada Universe Bond Index), Balanced portfolio (50% S&P/TSX Composite TR Index, 50% FTSE Canada Universe Bond Index). Cash uses a hypothetical 1.25% rate of return. Assumes reinvestment of all income and no transaction costs or taxes. Indices are not managed and it is not possible to invest directly in an index. The illustration is hypothetical and does not reflect actual results or the future returns or future value of a mutual fund or any other investment. Market timing comparison scenario assumes the following decisions: 'move to cash' at decision 1, 'reinvest' at decision 2, and 'stay invested' at decision 3." : "À titre indicatif seulement. Ce graphique illustre la croissance d'un placement hypothétique de [initialValue] dans le portefeuille de [chosenPortfolio] entre les 31 décembre 2002 et 2022. Les portefeuilles de croissance maximale, de croissance et équilibré dans le graphique sont hypothétiques et sont représentés par les indices suivants&nbsp;: 100&nbsp;% S&P/TSX composé (RT) (portefeuille de croissance maximale); 75&nbsp;% S&P/TSX composé (RT) et 25&nbsp;% FTSE Canada des obligations universelles (portefeuille de croissance); 50&nbsp;% S&P/TSX composé (RT) et 50&nbsp;% FTSE Canada des obligations universelles (portefeuille équilibré). Pour les liquidités, un taux de rendement hypothétique est de 1,25&nbsp;%. On suppose que tous les revenus sont réinvestis et qu'il n'y a pas de frais de transaction ni d'impôts. Les indices ne sont pas gérés et il n'est pas possible d'investir directement dans un indice. Ce graphique est hypothétique et ne reflète pas des résultats réels, ni la valeur future ou le rendement d'un fonds commun ou d'un quelconque placement. La simulation suppose que l'investisseur choisit d'investir à long terme à chaque moment décisif.";
    descriptions.push(illustrativePurposesDisclaimer);
    descriptions = descriptions.map((description) => {
        let changedDesc = description;

        if (description.indexOf("[initialValue") > -1) {
            changedDesc = changedDesc.replace(
                "[initialValue]",
                stageVars.investmentAmount && formatter.formatCurrency(stageVars.investmentAmount, 0)
            );
        } 
        if (description.indexOf("[chosenPortfolio") > -1) {
            changedDesc = changedDesc.replace(
                "[chosenPortfolio]",
                stageVars.chosenPortfolio && formatPortfolioAns(stageVars.chosenPortfolio)
            );
        } 
        if (description.indexOf("[preBrexitPortfolioWorth]") > -1) {
            changedDesc = changedDesc.replace(
                "[preBrexitPortfolioWorth]",
                stageVars.preBrexitPortfolioWorth && formatter.formatCurrency(stageVars.preBrexitPortfolioWorth, 0)
            );
            changedDesc = changedDesc.replace("[scene1Worth]", stageVars.portfolioWorth[0]);
        } 
        if (description.indexOf("[scene1Worth]") > -1) {
            changedDesc = changedDesc.replace("[scene1Worth]", stageVars.portfolioWorth[0]);
        } 
        if (description.indexOf("[scene2Worth]") > -1) {
            changedDesc = changedDesc.replace(
                "[prePandemicPortfolioWorth]",
                stageVars.prePandemicPortfolioWorth && formatter.formatCurrency(stageVars.prePandemicPortfolioWorth, 0)
            );
            changedDesc = changedDesc.replace("[scene2Worth]", stageVars.portfolioWorth[1]);
        } else if (description.indexOf("[continuouslyInvestedPortfolioWorth]") > -1) {
            changedDesc = changedDesc.replace(
                "[continuouslyInvestedPortfolioWorth]",
                stageVars.continuouslyInvestedPortfolioWorth
            );
        } 
        if (description.indexOf("[timingMarketPortfolioWorth]") > -1) {
            changedDesc = changedDesc.replace("[timingMarketPortfolioWorth]", stageVars.timingMarketPortfolioWorth);
        } 
        if (description.indexOf("[portfolioWorth]") > -1) {
            changedDesc = changedDesc.replace("[portfolioWorth]", stageVars.portfolioWorth[2]);
        }

        return changedDesc;
    });

    controls.updateTranscript(buildTranscriptHTML(descriptions), "#transcript-body", "transcript.html");
}

function sanitiseDescriptions(descriptions) {
    return descriptions
        .reduce((descs, currentDescription) => {
            if (currentDescription.text.indexOf("What do you do") !== -1) {
                if (currentDescription.duration !== 0) {
                    return descs.concat(currentDescription);
                } else {
                    return descs;
                }
            } else if (descs.map((desc) => desc.text).indexOf(currentDescription.text) === -1) {
                return descs.concat(currentDescription);
            }

            return descs;
        }, [])
        .sort(function (desc1, desc2) {
            if (desc1.startTime === desc2.startTime) {
                if (desc1.type === "caption" && desc2.type === "description") {
                    return 1;
                } else if (desc2.type === "caption" && desc1.type === "description") {
                    return -1;
                }
            }
            return desc1.startTime - desc2.startTime;
        })
        .map((currentDescription) => currentDescription.text);
}

$("#pgNavTaggle").on("click", () => {
    $(".fa-chevron-up").css("display", "");
});

export { getImageName, stageVars };
